import QuestionMarkCircle from 'svg/QuestionMarkCircle';
import LoadingSkeleton from 'components/LoadingSkeleton';
import AddressPreview from './AddressPreview';
import PreviewCard, { PreviewMedia } from './PreviewCard';
import VenueDetails from './VenueDetails';
import type { AddVenueState } from '../useAddVenue';

type Props = Pick<
  AddVenueState,
  | 'isManual'
  | 'selectedVenue'
  | 'selectedImageUrl'
  | 'isVenueLoading'
  | 'clearVenue'
  | 'manualAddress'
>;

export default function SelectionPreview({
  isManual,
  selectedVenue,
  selectedImageUrl,
  isVenueLoading,
  clearVenue,
  manualAddress,
}: Props) {
  if (isManual && manualAddress) {
    return <AddressPreview address={manualAddress.address} />;
  }

  if (!isManual && selectedVenue) {
    return <VenueDetails venue={selectedVenue} imageUrl={selectedImageUrl} onClear={clearVenue} />;
  }

  if (!isManual && isVenueLoading) {
    return (
      <PreviewCard>
        <PreviewMedia className="lg:h-[12.625rem]">
          <LoadingSkeleton className="absolute inset-0 !leading-none" height="100%" />
        </PreviewMedia>
        <div className="flex flex-col gap-ds-sm">
          <LoadingSkeleton height={18} width="70%" />
          <LoadingSkeleton height={24} width="85%" />
          <LoadingSkeleton height={18} width="40%" count={3} />
        </div>
      </PreviewCard>
    );
  }

  return (
    <div className="flex flex-col items-center gap-ds-md text-center">
      <QuestionMarkCircle className="h-[7.5rem] w-[7.5rem] text-color-bg-lightmode-primary dark:text-color-bg-darkmode-primary" />
      <p className="typography-product-heading-compact-desktop text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        No location selected
      </p>
      <p className="typography-product-caption text-color-text-lightmode-placeholder dark:text-color-text-darkmode-placeholder">
        Choose a location from the search results and it will appear here.
      </p>
    </div>
  );
}
